import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import api from "../../api/projects";
import {
  listProject,
  getCategories,
  updateProject,
  inviteCollaborators
} from "../../actions/projects";
import "react-quill/dist/quill.snow.css";

// import profileImage from '../../assets/profile.jpg'
import Nav from "../header/Nav.component";
import Loader from "../loader/Loader.component";
import ReactQuill from "react-quill";
const animatedComponents = makeAnimated();

const Summary = (props) => {
  const params = useParams();
  const dispatch = useDispatch();

  const [project, setProject] = useState(undefined);
  const [showModal, setShowModal] = useState(false);
  const [showCollabModal, setShowCollabModal] = useState(false);
  const [editDescription, setEditDescription] = useState(false);
  const [editTitle, setEditTitle] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const project_data = await api.get(`/projects/${params.id}`);
      if (project_data) {
        setProject(project_data.data);
      }
    }
    fetchData();
  }, []);

  const updateDescription = async () => {
    dispatch(
      updateProject(params.id, {
        overview: project.overview.replaceAll("<p><br></p>", ""),
      })
    );
    setEditDescription(false);
  };

  const updateTitle = async () => {
    dispatch(
      updateProject(params.id, {
        name: project.name,
      })
    );
    setEditTitle(false);
  };

  // const renderProjectCategories = (categories) => {
  //   const { projectsCategories } = this.props;
  //   if (projectsCategories) {
  //     let options = projectsCategories.map((c) => ({
  //       value: c.value,
  //       label: c.name,
  //       _id: c._id,
  //     }));
  //     if (!categories) {
  //       return (
  //         <span className="relative-loader">
  //           <Loader />
  //         </span>
  //       );
  //     }
  //     return (
  //       <Select
  //         closeMenuOnSelect={false}
  //         closeMenuOnScroll={false}
  //         defaultValue={categories.map((c) => ({
  //           value: c.value,
  //           label: c.name,
  //           _id: c._id,
  //         }))}
  //         isMulti
  //         components={animatedComponents}
  //         options={options}
  //         onChange={this.handleInputChange}
  //       />
  //     );
  //   }
  // };

  // Add New Collaborators ---
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleAddCollaborator = async (formValues) => {
    console.log(formValues);
    dispatch(
      inviteCollaborators(params.id, 
        {
          user_id: "6054074f8c41cc4",
          name: "User",
          email: formValues.email,
        }
      )
    );
    setProject({...project, collaborators: [...project.collaborators, {
      user_id: "6054074f8c41cc4",
      name: "User",
      email: formValues.email,
    }]})
    // console.log(this.state.collab_email)
    // alert('A name was submitted: ' + this.state.collab_email);
    setShowCollabModal(false);
  };

  return (
    <>
      <React.Fragment>
        <Nav />
        {!project ? (
          <div className="loader flex-center">
            <Loader />
          </div>
        ) : (
          <React.Fragment>
            <div className="content">
              <div className="column">
                <div className="boxed_section clear">
                  <div className="boxed_header">
                    <h3>{project.name}</h3>
                    <Link
                      to="#"
                      className="button interface"
                      onClick={() => setShowModal(true)}
                    >
                      Settings / Notifications
                    </Link>
                  </div>
                  <form className="category flex">
                    <label htmlFor="category">Project Category</label>
                    <div className="select">
                      {/* {renderProjectCategories(project.category)} */}
                    </div>
                  </form>
                </div>

                <div className="boxed_section">
                  <div className="boxed_header">
                    <h3>Description</h3>
                    {!editDescription ? (
                      <Link
                        to="#"
                        className="button"
                        onClick={() => setEditDescription(true)}
                      >
                        Edit
                      </Link>
                    ) : (
                      ""
                    )}
                  </div>
                  {editDescription ? (
                    <ReactQuill
                      theme="snow"
                      value={project.overview}
                      onChange={(x) => setProject({ ...project, overview: x })}
                      onBlur={updateDescription}
                    />
                  ) : (
                    <p dangerouslySetInnerHTML={{ __html: project.overview }} />
                  )}
                </div>

                <div className="boxed_section">
                  <div className="boxed_header">
                    <h3>Title</h3>
                    {!editTitle ? (
                      <Link
                        to="#"
                        className="button"
                        onClick={() => setEditTitle(true)}
                      >
                        Edit
                      </Link>
                    ) : (
                      ""
                    )}
                  </div>
                  {editTitle ? (
                    <input
                      type="text"
                      defaultValue={project.name}
                      onChange={(x) =>
                        setProject({ ...project, name: x.target.value })
                      }
                      onBlur={updateTitle}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          updateTitle();
                        }
                      }}
                    />
                  ) : (
                    <p>{project.name}</p>
                  )}
                </div>
              </div>
              {/* <!-- end column --> */}

              {/* <!-- Settings Modal --> */}
              <React.Fragment>
                {/* TODO: Render Project Settings Modal here.. */}
              </React.Fragment>
              <div className="column">
                <div className="boxed_section">
                  <div className="boxed_header">
                    <h3>Collaborators</h3>
                    <Link
                      onClick={() => setShowCollabModal(true)}
                      className="button interface"
                    >
                      Add
                    </Link>
                  </div>
                  {console.log(project)}
                  <div className="collaborators">
                    {project.collaborators ? (
                      project.collaborators.map((c) => {
                        return (
                          <div className="collaborator" key={c._id}>
                            <Link to="#" className="avatar">
                              <em>{c.name.substring(0, 2).toUpperCase()}</em>
                            </Link>
                            <p>
                              <strong>
                                <Link to="/">{c.name.toUpperCase()}</Link>
                              </strong>
                              {c.email.toLowerCase()}
                            </p>
                          </div>
                        );
                      })
                    ) : (
                      <p>Project does not has any collaboratoes.</p>
                    )}
                  </div>
                </div>

                <div className="boxed_section">
                  <div className="boxed_header">
                    <h3>Analysis Status</h3>
                    <Link to="/" className="button interface">
                      New
                    </Link>
                  </div>
                  <table id="myTable" className="display dataTable">
                    <thead>
                      <tr>
                        <th>Analytic Workflow</th>
                        <th>Version</th>
                        <th>Comments</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <Link to="/" className="highlight">
                            RNA-seq Alignment
                          </Link>
                          <p>08-03-2020 at 6:15pm</p>
                        </td>
                        <td>V2</td>
                        <td>
                          <Link to="/">2</Link>
                        </td>
                        <td>
                          <Link to="/" className="button processing">
                            Processing
                          </Link>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <Link to="/" className="highlight">
                            Fusion Transcript Detection
                          </Link>
                          <p>08-03-2020 at 6:15pm</p>
                        </td>
                        <td>V2</td>
                        <td>
                          <Link to="/">2</Link>
                        </td>
                        <td>
                          <Link to="/" className="button error">
                            Error
                          </Link>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <Link to="/" className="highlight">
                            My SkyGenic Project
                          </Link>
                          <p>08-03-2020 at 6:15pm</p>
                        </td>
                        <td>V2</td>
                        <td>
                          <Link to="/">2</Link>
                        </td>
                        <td>
                          <Link to="/" className="button">
                            complete
                          </Link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <Modal
              show={showCollabModal}
              onHide={() => setShowCollabModal(false)}
            >
              <Modal.Header closeButton>
                <h4>Add Collaborators</h4>
              </Modal.Header>
              <form onSubmit={handleSubmit(handleAddCollaborator)}>
                <Modal.Body>
                  <label>
                    Email:
                    <input
                      className="form-control"
                      name="email"
                      id="email"
                      type="text"
                      {...register("email", { required: true, maxLength: 80 })}
                    />
                  </label>
                  <br />
                  <label>
                    Permissions:
                    <select
                      name="permission"
                      {...register("permission", { required: true })}
                    >
                      <option value="X">X</option>
                      <option value="Y">Y</option>
                      <option value="Z">Z</option>
                    </select>
                  </label>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    defaultValue="Login"
                    data-wait="Please wait..."
                  >
                    Invite
                  </button>
                </Modal.Footer>
              </form>
            </Modal>
          </React.Fragment>
        )}
      </React.Fragment>
    </>
  );
};

export default Summary;
